module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-keyvue-pink.aabc827b.png";